export function activeGroupsInclude(
  activeGroups: string | undefined | null,
  groupId: string
): boolean {
  if (!activeGroups || !groupId) {
    return false;
  }

  return activeGroups
    .split(',')
    .map((group) => group.trim())
    .filter(Boolean)
    .includes(groupId);
}
